export default __webpack_public_path__ + "static/media/sp_without_successor.3d65731a.svg";